import * as style from './style.module.css';

const ButtonsContainer = ({ children }) => {
    return <div className={style.buttons}>
        {children}
    </div>
}

export default ButtonsContainer;
